import tokens from '@/PrimeVue/customDesignTokens';

export default {
  date: {
    selectedBackground: tokens.list.option.background.colors.selected
  }
};